const TeslaCard = ({ value }) => {

    return (
        <>
            <th scope="row">{value.idNodo}</th>
            <td>{value.lat}</td>
            <td>{value.lon}</td>
            <td>{value.activo}</td>
            <td>{value.tension}</td>
            <td>{value.corriente}</td>
            <td>{value.potencia}</td>
            <td>{value.fecha}</td>
            <td>{value.hora}</td>
        </>
    )

}

export default TeslaCard